module.exports = __webpack_public_path__ + "static/media/agenda.2328bdda.jpg";